import { line } from "d3"

// 列車表示位置、路線図に表示する駅一覧
export const TRAIN_POSITION_TABS = [
  { 
    lineId: 4,
    backgroundClass: 'd-TrainPosition-background d-TrainPosition-background--jr',
    stations: [
      {id: 42, kind: 'thruToJR', itemClass: 'd-TrainPosition-stationItem--top', lineClass: 'is_other', linkDisabled: true},
      {id: 10773, kind: 'normal', lineClass: 'is_other', linkDisabled: true},
      {id: 10279, kind: 'normal', lineClass: 'is_other', linkDisabled: true},
      {id: 41, kind: 'normal', lineClass: 'is_other', linkDisabled: true},
      {id: 11101, kind: 'normal', linkDisabled: true},
      {id: 11464, kind: 'normal', linkDisabled: true},
      {id: 28, kind: 'jrBranchEnd', lineClass: 'is_bottom is_right'},
    ]
  },
  { 
    lineId: 3,
    backgroundClass: 'd-TrainPosition-background d-TrainPosition-background--shinyokohama',
    stations: [
      [
        {id: 74, kind: 'thruToFukutoshin', itemClass: 'd-TrainPosition-stationItem--top', lineClass: 'is_branched_left is_other', linkDisabled: true},
        {id: 124, kind: 'thruToNambokuMita', itemClass: 'd-TrainPosition-stationItem--top', lineClass: 'is_branched_right is_other', linkDisabled: true}
      ],
      [
        {id: 73, kind: 'normal', lineClass: 'is_branched_left is_other', linkDisabled: true},
        {id: 123, kind: 'normal', lineClass: 'is_branched_right is_other', linkDisabled: true}
      ],
      [
        {id: 72, kind: 'normal', lineClass: 'is_branched_left is_other', linkDisabled: true},
        {id: 122, kind: 'normal', lineClass: 'is_branched_right is_other', linkDisabled: true}
      ],
      [
        {id: 71, kind: 'normal', lineClass: 'is_branched_left is_other', linkDisabled: true},
        {id: 121, kind: 'normal', lineClass: 'is_branched_right is_other', linkDisabled: true}
      ],
      [
        {id: 70, kind: 'normal', lineClass: 'is_branched_left is_other', linkDisabled: true},
        {id: 120, kind: 'normal', lineClass: 'is_branched_right is_other', linkDisabled: true}
      ],
      [
        {id: 69, kind: 'normal', lineClass: 'is_branched_left is_other', linkDisabled: true},
        {id: 119, kind: 'normal', lineClass: 'is_branched_right is_other', linkDisabled: true}
      ],
      [
        {id: 68, kind: 'normal', lineClass: 'is_branched_left is_other', linkDisabled: true},
        {id: 118, kind: 'normal', lineClass: 'is_branched_right is_other', linkDisabled: true}
      ],
      {id: 67, kind: 'tokyuParallel', lineClass: 'is_center is_other is_branching_top', linkDisabled: true},
      {id: 66, kind: 'tokyuParallel', lineClass: 'is_center is_other', linkDisabled: true},
      {id: 65, kind: 'tokyuParallel', lineClass: 'is_center is_other', linkDisabled: true},
      {id: 64, kind: 'tokyuParallel', lineClass: 'is_center is_other', linkDisabled: true},
      {id: 63, kind: 'tokyuParallel', lineClass: 'is_center is_other', linkDisabled: true},
      {id: 62, kind: 'tokyuParallel', lineClass: 'is_center is_other', linkDisabled: true},
      {id: 61, kind: 'normal', lineClass: 'is_center is_other', linkDisabled: true},
      {id: 29, kind: 'normal', lineClass: 'is_center'},
      {id: 28, kind: 'jrBranchStart', lineClass: 'is_center'},
      {id: 8, kind: 'shinyokohamaBranchEnd', lineClass: 'is_bottom is_right is_center'}
    ]
  },
  {
    lineId: 1,
    stations: [
      {id: 1, kind: 'start', lineClass: 'is_line_none'},
      {id: 2, kind: 'normal'},
      {id: 3, kind: 'normal'},
      {id: 4, kind: 'normal'},
      {id: 5, kind: 'normal'},
      {id: 6, kind: 'normal'},
      {id: 7, kind: 'normal'},
      {id: 8, kind: 'shinyokohamaBranchStart'},
      {id: 9, kind: 'normal'},
      {id: 10, kind: 'izuminoBranchStart'},
      {id: 11, kind: 'normal'},
      {id: 12, kind: 'normal'},
      {id: 13, kind: 'normal'},
      {id: 14, kind: 'normal'},
      {id: 15, kind: 'normal'},
      {id: 16, kind: 'normal'},
      {id: 17, kind: 'normal'},
      {id: 19, kind: 'normal'},
    ]
  },
  {
    lineId: 2,
    stations: [
      {id: 21, kind: 'izuminoBranchEnd', lineClass: 'is_top is_left'},
      {id: 22, kind: 'normal'},
      {id: 23, kind: 'normal'},
      {id: 24, kind: 'normal'},
      {id: 25, kind: 'normal'},
      {id: 26, kind: 'normal'},
      {id: 27, kind: 'normal'}
    ]
  }
]

// 路線マスタ
export const LINES = [
  {id: 1},
  {id: 2},
  {id: 3},
  {id: 4},
]

// 駅マスタ
// jrStation: JR線の駅 大崎〜川越、恵比寿、渋谷、西大井、武蔵小杉
// edgeStation: 遅れ時分を表示しない駅（終端駅）
export const STATIONS = [
  {
    id: 1,
    locationIds: [1, 2],
    transfers: [
      {name_ja: 'JR東日本', name_en: 'East Japan Railway Company', 'name_zh-cn': '东日本旅客铁路公司', name_ko: '동일본여객철도주식회사', icon: 'jr', lines: [
        {name_ja: '東海道線', name_en: 'Tōkaidō Line', 'name_zh-cn': '东海道线', name_ko: '도카이도선', icon: 'jt', query: 'jreastapp/1638/60/60'},
        {name_ja: '横須賀線', name_en: 'Yokosuka Line', 'name_zh-cn': '横须贺线', name_ko: '요코스카선', icon: 'jo', query: 'jreastapp/1638/69/69'},
        {name_ja: '京浜東北線', name_en: 'Keihin-Tōhoku Line', 'name_zh-cn': '京滨东北线', name_ko: '게이힌토호쿠선', icon: 'jk', query: 'jreastapp/1638/40/40'},
        {name_ja: '湘南新宿ライン', name_en: 'Shōnan-Shinjuku Line', 'name_zh-cn': '湘南新宿线', name_ko: '쇼난신주쿠라인', icon: 'js', query: 'jreastapp/1638/46-1/46-1'},
        {name_ja: '上野東京ライン', name_en: 'Ueno-Tōkyō Line', 'name_zh-cn': '上野东京线', name_ko: '우에노도쿄라인', icon: 'jut', query: 'jreastapp/1638/102-8/102-8'},
      ]},
      {name_ja: '東急電鉄', name_en: 'Tokyu Corporation', 'name_zh-cn': '东急电铁', name_ko: '도큐', icon: 'tokyu', lines: [
        {name_ja: '東横線', name_en: 'Tōyoko Line', 'name_zh-cn': '东横线', name_ko: '도요코선', icon: 'tokyu-ty', query: 'tokyuapp/5/26001'},
      ]},
      {name_ja: '京浜急行電鉄', name_en: 'Keikyū Line', 'name_zh-cn': '京急线', name_ko: '게이큐선', icon: 'keikyu', lines: [
        {name_ja: '本線', name_en: 'Keikyū Main Line', 'name_zh-cn': '京急本线', name_ko: '게이큐 본선', icon: 'keikyu-kk', query: 'keikyuapp/KK37'},
      ]},
      {name_ja: '横浜市営地下鉄', name_en: 'Yokohama Municipal Subway', 'name_zh-cn': '横滨市交通局', name_ko: '요코하마시 교통국', icon: 'yokohama-municipal', minAppVersion: '1.6.0', lines: [
        {name_ja: 'ブルーライン', name_en: 'BLUE LINE', 'name_zh-cn': '蓝线', name_ko: '블루라인', icon: 'yokohama-blueline', url: 'https://navi.hamabus.city.yokohama.lg.jp/koutuu/smart/top/Top?window=trainLocation&initialLine=blue&initialNodeId=00000838'},
      ]},
    ],
    edgeStation: true,
    stopKindIds: [8,6,7,4]
  },
  { id: 2, locationIds: [1], stopKindIds: [4]},
  { id: 3, locationIds: [1], stopKindIds: [4]},
  { id: 4, locationIds: [1], stopKindIds: [4]},
  { id: 5, locationIds: [1], stopKindIds: [7,4]},
  { id: 6, locationIds: [1], stopKindIds: [4]},
  { id: 7, locationIds: [1], stopKindIds: [4]},
  { id: 8, locationIds: [1], stopKindIds: [100,200,210,8,5,6,7,104,204,214,4]}, // 西谷
  { id: 9, locationIds: [1], stopKindIds: [5,6,7,104,204,214,4]}, // 鶴ヶ峰
  { id: 10, locationIds: [1], stopKindIds: [100,200,210,8,5,6,7,104,204,214,4]},// 二俣川
  { id: 11, locationIds: [1], stopKindIds: [6,7,104,204,214,4]},
  { id: 12, locationIds: [1], stopKindIds: [6,7,104,204,214,4]},
  { id: 13, locationIds: [1], stopKindIds: [6,7,104,204,214,4]},
  { 
    id: 14,
    locationIds: [1],
    transfers: [
      {name_ja: '小田急電鉄', name_en: 'Odakyu Electric Railway', 'name_zh-cn': '小田急电铁', name_ko: '오다큐 전철', icon: 'odakyu', lines: [
        {name_ja: '江ノ島線', name_en: 'Enoshima Line', 'name_zh-cn': '江之岛线', name_ko: '에노시마선', icon: 'odakyu-oe', query: 'odakyuapp/055'},
      ]}
    ],
    stopKindIds: [100,200,210,8,6,7,104,204,214,4]
  },
  { id: 15, locationIds: [1], stopKindIds: [6,7,104,204,214,4]},
  { id: 16, locationIds: [1], stopKindIds: [6,7,104,204,214,4]},
  { id: 17, locationIds: [1, 2], stopKindIds: [6,7,104,204,214,4]},
  {
    id: 19,
    locationIds: [1],
    transfers: [
      {name_ja: '小田急電鉄', name_en: 'Odakyu Electric Railway', 'name_zh-cn': '小田急电铁', name_ko: '오다큐 전철', icon: 'odakyu', lines: [
        {id: 201, name_ja: '小田原線', name_en: 'Odawara Line', 'name_zh-cn': '小田原线', name_ko: '오다와라선', icon: 'odakyu-oh', query: 'odakyuapp/032'},
      ]}
    ],
    edgeStation: true,
    stopKindIds: [100,200,210,8,6,7,104,204,214,4]
  }, // 海老名

  { id: 21, locationIds: [1], stopKindIds: [6,7,204,4]},
  { id: 22, locationIds: [1], stopKindIds: [6,7,204,4]},
  { id: 23, locationIds: [1], stopKindIds: [6,7,204,4]},
  { id: 24, locationIds: [1], stopKindIds: [200,5,6,7,204,4]},
  { id: 25, locationIds: [1], stopKindIds: [6,7,204,4]},
  { id: 26, locationIds: [1], stopKindIds: [6,7,204,4]},
  {
    id: 27,
    locationIds: [1],
    transfers: [
      {name_ja: '小田急電鉄', name_en: 'Odakyu Electric Railway', 'name_zh-cn': '小田急电铁', name_ko: '오다큐 전철', icon: 'odakyu', lines: [
        {name_ja: '江ノ島線', name_en: 'Enoshima Line', 'name_zh-cn': '江之岛线', name_ko: '에노시마선', icon: 'odakyu-oe', query: 'odakyuapp/059'},
      ]},
      {name_ja: '横浜市営地下鉄', name_en: 'Yokohama Municipal Subway', 'name_zh-cn': '横滨市交通局', name_ko: '요코하마시 교통국', icon: 'yokohama-municipal', minAppVersion: '1.6.0', lines: [
        {name_ja: 'ブルーライン', name_en: 'BLUE LINE', 'name_zh-cn': '蓝线', name_ko: '블루라인', icon: 'yokohama-blueline', url: 'https://navi.hamabus.city.yokohama.lg.jp/koutuu/smart/top/Top?window=trainLocation&initialLine=blue&initialNodeId=00003894'},
      ]},
    ],
    edgeStation: true,
    stopKindIds: [200,5,6,7,204,4]
  },
  { id: 28, locationIds: [1], stopKindIds: [100,200,210,8,104,204,214,4]}, // 羽沢横浜国大

   // 新横浜
  { 
    id: 29,
    locationIds: [1],
    transfers: [
      {name_ja: 'JR東日本', name_en: 'East Japan Railway Company', 'name_zh-cn': '东日本旅客铁路公司', name_ko: '동일본여객철도주식회사', icon: 'jr', lines: [
        {name_ja: '横浜線', name_en: 'Yokohama Line', 'name_zh-cn': '横滨线', name_ko: '요코하마선', icon: 'jh', query: 'jreastapp/0888/70/70'},
      ]},
      {name_ja: 'JR東海', name_en: 'Central Japan Railway Company', 'name_zh-cn': 'JR东海', name_ko: 'JR토카이', icon: 'jr-central', minAppVersion: '1.6.0', lines: [
        {name_ja: '東海道新幹線', name_en: 'Tokaido Shinkansen', 'name_zh-cn': '東海道新幹線', name_ko: '도카이도신칸센', icon: 'tokaido-shinkansen', url: 'https://traininfo.jr-central.co.jp/shinkansen/sp/ja/ti08.html?station=3'},
      ]},
      {name_ja: '横浜市営地下鉄', name_en: 'Yokohama Municipal Subway', 'name_zh-cn': '横滨市交通局', name_ko: '요코하마시 교통국', icon: 'yokohama-municipal', minAppVersion: '1.6.0', lines: [
        {name_ja: 'ブルーライン', name_en: 'BLUE LINE', 'name_zh-cn': '蓝线', name_ko: '블루라인', icon: 'yokohama-blueline', url: 'https://navi.hamabus.city.yokohama.lg.jp/koutuu/smart/top/Top?window=trainLocation&initialLine=blue&initialNodeId=00004179'},
      ]},
    ],
    stopKindIds: [200,210,8,204,214,4],
    tokyuKYId: 983
  },

  { id: 41, locationIds: [], jrStation: true}, // 大崎
  { id: 42, locationIds: [], jrStation: true}, // 新宿
  { id: 43, locationIds: [], jrStation: true}, // 池袋
  { id: 44, locationIds: [], jrStation: true}, // 赤羽
  { id: 45, locationIds: [], jrStation: true}, // 武蔵浦和
  { id: 46, locationIds: [], jrStation: true}, // 大宮
  { id: 47, locationIds: [], jrStation: true}, // 南古谷
  { id: 48, locationIds: [], jrStation: true}, // 川越
  { id: 49, locationIds: [], jrStation: true}, // JR線直通
  { id: 50, locationIds: [], jrStation: true}, // 品川
  { id: 51, locationIds: [], jrStation: true}, // 板橋
  { id: 52, locationIds: [], jrStation: true}, // 指扇


  { id: 10279, locationIds: [], jrStation: true}, // 恵比寿
  { id: 10773, locationIds: [], jrStation: true}, // 渋谷
  { id: 11101, locationIds: [], jrStation: true}, // 西大井
  { id: 11464, locationIds: [], jrStation: true}, // 武蔵小杉

  { id: 61, locationIds: [], tokyuKYId: 982 }, // 新綱島
  { id: 62, locationIds: [], tokyuKYId: 919 }, // 日吉

  { id: 63, locationIds: [], tokyuKYId: 918 }, // 元住吉
  { id: 64, locationIds: [], tokyuKYId: 57 },  // 武蔵小杉
  { id: 65, locationIds: [], tokyuKYId: 916 }, // 新丸子
  { id: 66, locationIds: [], tokyuKYId: 915 }, // 多摩川
  { id: 67, locationIds: [], tokyuKYId: 914 }, // 田園調布

  { id: 68, locationIds: [], tokyuKYId: 913 }, // 自由が丘
  { id: 69, locationIds: [], tokyuKYId: 912 },
  { id: 70, locationIds: [], tokyuKYId: 911 }, // 学芸大学
  { id: 71, locationIds: [], tokyuKYId: 910 },
  { id: 72, locationIds: [], tokyuKYId: 909 }, // 中目黒
  { id: 73, locationIds: [], tokyuKYId: 908 },
  { id: 74, locationIds: [], tokyuKYId: 26 },  // 渋谷

  { id: 118, locationIds: [], tokyuKYId: 934 }, // 奥沢
  { id: 119, locationIds: [], tokyuKYId: 933 }, // 大岡山
  { id: 120, locationIds: [], tokyuKYId: 932 },
  { id: 121, locationIds: [], tokyuKYId: 931 },
  { id: 122, locationIds: [], tokyuKYId: 930 }, // 武蔵小山
  { id: 123, locationIds: [], tokyuKYId: 929 },
  { id: 124, locationIds: [], tokyuKYId: 24 },  // 目黒

  { id: 75 },  // 新宿三丁
  { id: 76 },  // 池袋
  { id: 77 },  // 
  { id: 78 },  // 
  { id: 79 },  // 和光市
  { id: 80 },  // 
  { id: 81 },  // 
  { id: 82 },  // 
  { id: 83 },  // 
  { id: 84 },  // 
  { id: 85 },  // 
  { id: 86 },  // 小川町
  { id: 87 },  // 練馬
  { id: 88 },  // 
  { id: 89 },  // 
  { id: 90 },  // 
  { id: 91 },  // 所沢
  { id: 92 },  // 
  { id: 93 },  // 
  { id: 94 },  // 
  { id: 95 },  // 飯能
  { id: 96 },  // 武蔵丘
  { id: 97 },  // 西武球場前
  { id: 98 },  // 東急直通

  { id: 125 },  // 白金高輪
  { id: 126 },  // 
  { id: 127 },  // 
  { id: 128 },  // 
  { id: 129 },  // 
  { id: 130 },  // 
  { id: 131 },  // 
  { id: 132 },  // 
  { id: 133 },  // 浦和美園
  { id: 134 },  // 三田
  { id: 135 },  // 
  { id: 136 },  // 
  { id: 137 },  // 
  { id: 138 },  // 
  { id: 139 },  // 
  { id: 140 },  // 
  { id: 141 },  // 西高島平

  // Navitimeデータ取得のためマスターに追加した東横線の行先駅
  { id: 30093, line_ids: [] },  // 菊名
  { id: 30098, line_ids: [] },  // 横浜
  { id: 30100, line_ids: [] },  // みなとみらい
  { id: 30103, line_ids: [] },  // 元町・中華街


  // 以下、東急TIDの行き先にのみ存在する駅
  { id: 41001, line_ids: [312] },  // 副都心線直通
  { id: 41002, line_ids: [313] },  // 東武東上線直通
  { id: 41003, line_ids: [314] },  // 西武線直通

  { id: 42001, line_ids: [322, 323, 324] },  // 南北線・三田線直通
  { id: 42002, line_ids: [322, 323] },  // 南北線直通
  { id: 42003, line_ids: [324] },  // 三田線直通
  
]

// tid-converter/db/fixtures/10_train_kind.rb と同一、abbr_name_ja(列車位置画面で表示する列車種別), station_detail_name_*(駅詳細画面の上部に表示する停車種別), station_detail_order(駅詳細画面の上部に表示する停車種別の並び順), is_jr(JR線直通)を追加
// id: 100以降はフロント側のみで使用するため追加したJR線直通種別
export const TRAIN_KINDS = [
  // 0: 未使用
  {id:  0, abbr_name_ja: '特', name_ja: '特急', 'name_zh-cn': '特快', name_ko: '특급', name_en: 'Ltd. Exp.', navitime_name: '特急', station_detail_name_ja: '特急', 'station_detail_name_zh-cn': '特快', station_detail_name_ko: '특급', station_detail_name_en: 'Ltd. Exp.', routemap_name_ja: '特急', 'routemap_name_zh-cn': '特快', routemap_name_ko: '특급', routemap_name_en: 'Limited exp.',
   station_detail_order: 2, is_jr: false, icon_class: 'is_limitedExpress'},

  {id:  1, abbr_name_ja: '急', name_ja: '急行', 'name_zh-cn': '直达', name_ko: '급행', name_en: 'Exp.', navitime_name: '急行', station_detail_name_ja: '急行', 'station_detail_name_zh-cn': '直达', station_detail_name_ko: '급행', station_detail_name_en: 'Exp.', routemap_name_ja: '急行', 'routemap_name_zh-cn': '直达', routemap_name_ko: '급행', routemap_name_en: 'Express',
   station_detail_order: 4, is_jr: false, icon_class: 'is_express'},

   // 2: 未使用
  {id:  2, abbr_name_ja: '快', name_ja: '快速', 'name_zh-cn': '快速', name_ko: '쾌속', name_en: 'Rapid', navitime_name: '快速', station_detail_name_ja: '快速', 'station_detail_name_zh-cn': '快速', station_detail_name_ko: '쾌속', station_detail_name_en: 'Rapid', routemap_name_ja: '快速', 'routemap_name_zh-cn': '快速', routemap_name_ko: '쾌속', routemap_name_en: 'Rapid',
   station_detail_order: 6, is_jr: false, icon_class: 'is_rapid'},

  {id:  4, abbr_name_ja: '各', name_ja: '各停', 'name_zh-cn': '普通', name_ko: '각역정차', name_en: 'Local', navitime_name: '各停', station_detail_name_ja: '各停', 'station_detail_name_zh-cn': '普通', station_detail_name_ko: '각역정차', station_detail_name_en: 'Local', routemap_name_ja: '各停', 'routemap_name_zh-cn': '普通', routemap_name_ko: '각역정차', routemap_name_en: 'Local',
   station_detail_order: 8, is_jr: false, icon_class: 'is_local'},
  {id:  5, abbr_name_ja: '通', name_ja: '通勤特急', 'name_zh-cn': '通勤特快', name_ko: '통근특급', name_en: 'Com.Ltd.Exp.', navitime_name: '通勤特急', station_detail_name_ja: '通特', 'station_detail_name_zh-cn': '通勤特快', station_detail_name_ko: '통근특급', station_detail_name_en: 'Com.Ltd.Exp.', routemap_name_ja: '通勤特急', 'routemap_name_zh-cn': '通勤特快', routemap_name_ko: '통근특급', routemap_name_en: 'Commuter Limited exp.',
   station_detail_order: 3, is_jr: false, icon_class: 'is_commuterLimitedExpress'},
  {id:  6, abbr_name_ja: '通', name_ja: '通勤急行', 'name_zh-cn': '通勤直达', name_ko: '통근급행', name_en: 'Com.Exp.', navitime_name: '通勤急行', station_detail_name_ja: '通急', 'station_detail_name_zh-cn': '通勤直达', station_detail_name_ko: '통근급행', station_detail_name_en: 'Com.Exp.', routemap_name_ja: '通勤急行', 'routemap_name_zh-cn': '通勤直达', routemap_name_ko: '통근급행', routemap_name_en: 'Commuter exp.',
   station_detail_order: 5, is_jr: false, icon_class: 'is_commuterExpress'},
  {id:  7, abbr_name_ja: '快', name_ja: '快速', 'name_zh-cn': '快速', name_ko: '쾌속', name_en: 'Rapid', navitime_name: '快速', station_detail_name_ja: '快速', 'station_detail_name_zh-cn': '快速', station_detail_name_ko: '쾌속', station_detail_name_en: 'Rapid', routemap_name_ja: '快速', 'routemap_name_zh-cn': '快速', routemap_name_ko: '쾌속', routemap_name_en: 'Rapid',
   station_detail_order: 6, is_jr: false, icon_class: 'is_rapid'},
  {id:  8, abbr_name_ja: '特', name_ja: '特急', 'name_zh-cn': '特快', name_ko: '특급', name_en: 'Ltd. Exp.', navitime_name: '特急', station_detail_name_ja: '特急', 'station_detail_name_zh-cn': '特快', station_detail_name_ko: '특급', station_detail_name_en: 'Ltd. Exp.', routemap_name_ja: '特急', 'routemap_name_zh-cn': '特快', routemap_name_ko: '특급', routemap_name_en: 'Limited exp.',
   station_detail_order: 2, is_jr: false, icon_class: 'is_limitedExpress'},

   // 100, 104は相鉄線内でのJR線直通
  {id:  100, abbr_name_ja: '特', name_ja: '特急', 'name_zh-cn': '特快', name_ko: '특급', name_en: 'Ltd. Exp.', navitime_name: '特急', station_detail_name_ja: '特急', 'station_detail_name_zh-cn': '特快', station_detail_name_ko: '특급', station_detail_name_en: 'Ltd. Exp.',
   station_detail_order: 1, is_jr: true, icon_class: 'is_jr'},
  {id:  104, abbr_name_ja: '各', name_ja: '各停', 'name_zh-cn': '普通', name_ko: '각역정차', name_en: 'Local', navitime_name: '各停', station_detail_name_ja: '各停', 'station_detail_name_zh-cn': '普通', station_detail_name_ko: '각역정차', station_detail_name_en: 'Local',
   station_detail_order: 7, is_jr: true, icon_class: 'is_jr'},

   // 200, 204は相鉄線内での東横線直通
  {id:  200, abbr_name_ja: '特', name_ja: '特急', 'name_zh-cn': '特快', name_ko: '특급', name_en: 'Ltd. Exp.', navitime_name: '特急', station_detail_name_ja: '特急', 'station_detail_name_zh-cn': '特快', station_detail_name_ko: '특급', station_detail_name_en: 'Ltd. Exp.',
   station_detail_order: 1, is_jr: false, icon_class: 'is_toyoko'},
  {id:  204, abbr_name_ja: '各', name_ja: '各停', 'name_zh-cn': '普通', name_ko: '각역정차', name_en: 'Local', navitime_name: '各停', station_detail_name_ja: '各停', 'station_detail_name_zh-cn': '普通', station_detail_name_ko: '각역정차', station_detail_name_en: 'Local',
   station_detail_order: 7, is_jr: false, icon_class: 'is_toyoko'},

   // 210, 214は相鉄線内での目黒線直通
  {id:  210, abbr_name_ja: '特', name_ja: '特急', 'name_zh-cn': '特快', name_ko: '특급', name_en: 'Ltd. Exp.', navitime_name: '特急', station_detail_name_ja: '特急', 'station_detail_name_zh-cn': '特快', station_detail_name_ko: '특급', station_detail_name_en: 'Ltd. Exp.',
   station_detail_order: 1, is_jr: true, icon_class: 'is_meguro'},
  {id:  214, abbr_name_ja: '各', name_ja: '各停', 'name_zh-cn': '普通', name_ko: '각역정차', name_en: 'Local', navitime_name: '各停', station_detail_name_ja: '各停', 'station_detail_name_zh-cn': '普通', station_detail_name_ko: '각역정차', station_detail_name_en: 'Local',
   station_detail_order: 7, is_jr: true, icon_class: 'is_meguro'},

  {id:  10002, jr_train_type: '02', abbr_name_ja: '快', name_ja: '快速', 'name_zh-cn': '快速', name_ko: '쾌속', name_en: 'Rapid', navitime_name: '快速', station_detail_name_ja: '快速', 'station_detail_name_zh-cn': '快速', station_detail_name_ko: '쾌속', station_detail_name_en: 'Rapid', routemap_name_ja: '快速', 'routemap_name_zh-cn': '快速', routemap_name_ko: '쾌속', routemap_name_en: 'Rapid',
   is_jr: true, icon_class: 'is_jr'},
  {id:  10004, jr_train_type: '04', abbr_name_ja: '通', name_ja: '通勤快速', 'name_zh-cn': '通勤快速', name_ko: '통근쾌속', name_en: 'Com.Rapid', navitime_name: '通勤快速', station_detail_name_ja: '通快', 'station_detail_name_zh-cn': '通勤快速', station_detail_name_ko: '통근쾌속', station_detail_name_en: 'Com.Rapid', routemap_name_ja: '通勤快速', 'routemap_name_zh-cn': '通勤快速', routemap_name_ko: '통근쾌속', routemap_name_en: 'Commuter Rapid',
   is_jr: true, icon_class: 'is_jr'},
  {id:  10019, jr_train_type: '19', abbr_name_ja: '各', name_ja: '各停', 'name_zh-cn': '普通', name_ko: '각역정차', name_en: 'Local', navitime_name: '各停', station_detail_name_ja: '各停', 'station_detail_name_zh-cn': '普通', station_detail_name_ko: '각역정차', station_detail_name_en: 'Local',
   is_jr: true, icon_class: 'is_jr'},

  {id:  20002, tokyu_train_kind_id: 2, abbr_name_ja: '各', name_ja: '各停', 'name_zh-cn': '普通', name_ko: '각역정차', name_en: 'Local', navitime_name: '各停', station_detail_name_ja: '各停', 'station_detail_name_zh-cn': '普通', station_detail_name_ko: '각역정차', station_detail_name_en: 'Local', routemap_name_ja: '各停', 'routemap_name_zh-cn': '普通', routemap_name_ko: '각역정차', routemap_name_en: 'Local',
   station_detail_order: 8, is_jr: false, icon_class: 'is_local'},
  {id:  20003, tokyu_train_kind_id: 3, abbr_name_ja: '快', name_ja: '快速', 'name_zh-cn': '快速', name_ko: '쾌속', name_en: 'Rapid', navitime_name: '快速', station_detail_name_ja: '快速', 'station_detail_name_zh-cn': '快速', station_detail_name_ko: '쾌속', station_detail_name_en: 'Rapid', routemap_name_ja: '快速', 'routemap_name_zh-cn': '快速', routemap_name_ko: '쾌속', routemap_name_en: 'Rapid',
   station_detail_order: 6, is_jr: false, icon_class: 'is_rapid'},
  {id:  20004, tokyu_train_kind_id: 4, abbr_name_ja: '急', name_ja: '急行', 'name_zh-cn': '直达', name_ko: '급행', name_en: 'Exp.', navitime_name: '急行', station_detail_name_ja: '急行', 'station_detail_name_zh-cn': '直达', station_detail_name_ko: '급행', station_detail_name_en: 'Exp.', routemap_name_ja: '急行', 'routemap_name_zh-cn': '直达', routemap_name_ko: '급행', routemap_name_en: 'Express',
   station_detail_order: 4, is_jr: false, icon_class: 'is_express'},
  {id:  20005, tokyu_train_kind_id: 5, abbr_name_ja: '特', name_ja: '特急', 'name_zh-cn': '特快', name_ko: '특급', name_en: 'Ltd. Exp.', navitime_name: '特急', station_detail_name_ja: '特急', 'station_detail_name_zh-cn': '特快', station_detail_name_ko: '특급', station_detail_name_en: 'Ltd. Exp.', routemap_name_ja: '特急', 'routemap_name_zh-cn': '特快', routemap_name_ko: '특급', routemap_name_en: 'Limited exp.',
   station_detail_order: 2, is_jr: false, icon_class: 'is_limitedExpress'},
  {id:  20007, tokyu_train_kind_id: 7, abbr_name_ja: 'Ｆ', name_ja: 'Ｆライナー', 'name_zh-cn': 'Ｆライナー', name_ko: 'Ｆライナー', name_en: 'Ｆライナー', navitime_name: 'Ｆライナー', station_detail_name_ja: 'Ｆライナー', 'station_detail_name_zh-cn': 'Ｆライナー', station_detail_name_ko: 'Ｆライナー', station_detail_name_en: 'Ｆライナー', routemap_name_ja: 'Ｆライナー', 'routemap_name_zh-cn': 'Ｆライナー', routemap_name_ko: 'Ｆライナー', routemap_name_en: 'Ｆライナー',
   station_detail_order: 2, is_jr: false, icon_class: 'is_limitedExpress'},
  {id:  20011, tokyu_train_kind_id: 11, abbr_name_ja: '通', name_ja: '通勤特急', 'name_zh-cn': '通勤特快', name_ko: '통근특급', name_en: 'Com.Ltd.Exp.', navitime_name: '通勤特急', station_detail_name_ja: '通特', 'station_detail_name_zh-cn': '通勤特快', station_detail_name_ko: '통근특급', station_detail_name_en: 'Com.Ltd.Exp.', routemap_name_ja: '通勤特急', 'routemap_name_zh-cn': '通勤特快', routemap_name_ko: '통근특급', routemap_name_en: 'Commuter Limited exp.',
   station_detail_order: 3, is_jr: false, icon_class: 'is_limitedExpress'},
  {id:  20012, tokyu_train_kind_id: 12, abbr_name_ja: 'Ｓ', name_ja: 'Ｓトレイン', 'name_zh-cn': 'Ｓトレイン', name_ko: 'Ｓトレイン', name_en: 'Ｓトレイン', navitime_name: 'Ｓトレイン', station_detail_name_ja: 'Ｓトレイン', 'station_detail_name_zh-cn': 'Ｓトレイン', station_detail_name_ko: 'Ｓトレイン', station_detail_name_en: 'Ｓトレイン', routemap_name_ja: 'Ｓトレイン', 'routemap_name_zh-cn': 'Ｓトレイン', routemap_name_ko: 'Ｓトレイン', routemap_name_en: 'Ｓトレイン',
   station_detail_order: 2, is_jr: false, icon_class: 'is_limitedExpress'}, 

  // 新横浜線の東急窓で未知の種別
  {id:  99999, abbr_name_ja: '', name_ja: '', 'name_zh-cn': '', name_ko: '', name_en: '', navitime_name: '', station_detail_name_ja: '', 'station_detail_name_zh-cn': '', station_detail_name_ko: '', station_detail_name_en: '', routemap_name_ja: '', 'routemap_name_zh-cn': '', routemap_name_ko: '', routemap_name_en: '',
   station_detail_order: 99999, is_jr: false, icon_class: 'is_local'}, 
  ]

// 東急線内駅間section_id->次駅の対応テーブル 
export const TOKYU_SECTIONS = [
  // 東横線上り
  {section_id: 2, tokyuKYId: 26}, // 代官山〜渋谷
  {section_id: 3, tokyuKYId: 908},
  {section_id: 4, tokyuKYId: 909},
  {section_id: 5, tokyuKYId: 910},
  {section_id: 6, tokyuKYId: 911},
  {section_id: 7, tokyuKYId: 912}, // 自由が丘〜都立大学
  {section_id: 8, tokyuKYId: 913}, // 田園調布〜自由が丘
  {section_id: 9, tokyuKYId: 914}, // 多摩川〜田園調布
  {section_id: 10, tokyuKYId: 915},
  {section_id: 11, tokyuKYId: 916}, // 新丸子〜武蔵小杉
  {section_id: 12, tokyuKYId: 57}, 
  {section_id: 13, tokyuKYId: 918}, // 元住吉〜日吉
  // 東横線下り
  {section_id: 24, tokyuKYId: 908}, // 代官山〜渋谷
  {section_id: 25, tokyuKYId: 909},
  {section_id: 26, tokyuKYId: 910},
  {section_id: 27, tokyuKYId: 911},
  {section_id: 28, tokyuKYId: 912},
  {section_id: 29, tokyuKYId: 913}, // 自由が丘〜都立大学
  {section_id: 30, tokyuKYId: 914}, // 田園調布〜自由が丘
  {section_id: 31, tokyuKYId: 915}, // 多摩川〜田園調布
  {section_id: 32, tokyuKYId: 916},
  {section_id: 33, tokyuKYId: 57}, // 新丸子〜武蔵小杉
  {section_id: 34, tokyuKYId: 918}, 
  {section_id: 35, tokyuKYId: 919}, // 元住吉〜日吉 
  // 目黒線上り
  {section_id: 46, tokyuKYId: 24}, // 不動前〜目黒
  {section_id: 47, tokyuKYId: 929}, // 武蔵小山〜不動前
  {section_id: 48, tokyuKYId: 930}, // 西小山〜武蔵小山
  {section_id: 49, tokyuKYId: 931}, // 洗足〜西小山
  {section_id: 50, tokyuKYId: 932}, // 大岡山〜洗足
  {section_id: 51, tokyuKYId: 933}, // 奥沢〜大岡山
  {section_id: 52, tokyuKYId: 934}, // 田園調布〜奥沢
  {section_id: 53, tokyuKYId: 914}, // 多摩川〜田園調布
  {section_id: 54, tokyuKYId: 915},
  {section_id: 55, tokyuKYId: 916}, // 新丸子〜武蔵小杉
  {section_id: 56, tokyuKYId: 57}, 
  {section_id: 57, tokyuKYId: 918}, // 元住吉〜日吉 
  // 目黒線下り
  {section_id: 59, tokyuKYId: 929}, // 不動前〜目黒
  {section_id: 60, tokyuKYId: 930}, // 武蔵小山〜不動前
  {section_id: 61, tokyuKYId: 931}, // 西小山〜武蔵小山
  {section_id: 62, tokyuKYId: 932}, // 洗足〜西小山
  {section_id: 63, tokyuKYId: 933}, // 大岡山〜洗足
  {section_id: 64, tokyuKYId: 934}, // 奥沢〜大岡山
  {section_id: 65, tokyuKYId: 914}, // 田園調布〜奥沢
  {section_id: 66, tokyuKYId: 915}, // 多摩川〜田園調布
  {section_id: 67, tokyuKYId: 916},
  {section_id: 68, tokyuKYId: 57}, // 新丸子〜武蔵小杉
  {section_id: 69, tokyuKYId: 918}, 
  {section_id: 70, tokyuKYId: 919}, // 元住吉〜日吉 
  // 新横浜線上り
  {section_id: 263, tokyuKYId: 919}, // 新綱島〜日吉
  {section_id: 264, tokyuKYId: 982}, // 新横浜〜新綱島 
  // 新横浜線下り
  {section_id: 265, tokyuKYId: 982}, // 日吉〜新綱島
  {section_id: 266, tokyuKYId: 983}, // 新綱島〜新横浜   
]

export const TOKYU_DESTINATION_CODES = [
  {code: 2, name: '西武球場前', station_id: 97},
  {code: 3, name: '西武秩父', station_id: null},
  {code: 4, name: '飯能', station_id: 95},
  {code: 5, name: '入間市', station_id: 94},
  {code: 6, name: '小手指', station_id: 93},
  {code: 7, name: '西所沢', station_id: 92},
  {code: 8, name: '所沢', station_id: 91},
  {code: 9, name: '清瀬', station_id: 90},
  {code: 10, name: '保谷', station_id: 89},
  {code: 11, name: '石神井公園', station_id: 88},
  {code: 12, name: '練馬高野台', station_id: null},
  {code: 13, name: '練馬', station_id: 87},
  {code: 15, name: '西武線直通', station_id: 41003},
  {code: 17, name: '小川町', station_id: 86},
  {code: 18, name: '森林公園', station_id: 85},
  {code: 19, name: '坂戸', station_id: 83},
  {code: 20, name: '川越市', station_id: 82},
  {code: 21, name: '上福岡', station_id: 81},
  {code: 22, name: '志木', station_id: 80},
  {code: 24, name: '東武東上線直通', station_id: 41002},
  {code: 26, name: '和光市', station_id: 79},
  {code: 27, name: '地下鉄成増', station_id: 78},
  {code: 28, name: '小竹向原', station_id: 77},
  {code: 29, name: '千川', station_id: null},
  {code: 30, name: '池袋', station_id: 76},
  {code: 31, name: '新宿三丁目', station_id: 75},
  {code: 33, name: '副都心線直通', station_id: 41001},
  {code: 36, name: '北千住', station_id: null},
  {code: 37, name: '南千住', station_id: null},
  {code: 38, name: '八丁堀', station_id: null},
  {code: 39, name: '霞ケ関', station_id: null},
  {code: 40, name: '広尾', station_id: null},
  {code: 42, name: '日比谷線直通', station_id: null},
  {code: 80, name: '中目黒', station_id: null},
  {code: 45, name: '西高島平', station_id: 141},
  {code: 46, name: '高島平', station_id: 140},
  {code: 47, name: '本蓮沼', station_id: 139},
  {code: 48, name: '新板橋', station_id: 138},
  {code: 49, name: '巣鴨', station_id: 137},
  {code: 50, name: '水道橋', station_id: null},
  {code: 51, name: '日比谷', station_id: 136},
  {code: 52, name: '芝公園', station_id: null},
  {code: 54, name: '三田線直通', station_id: 42003},
  {code: 57, name: '浦和美園', station_id: 133},
  {code: 58, name: '東川口', station_id: null},
  {code: 59, name: '鳩ヶ谷', station_id: 132},
  {code: 60, name: '赤羽岩淵', station_id: 131},
  {code: 61, name: '王子神谷', station_id: 130},
  {code: 62, name: '駒込', station_id: 129},
  {code: 63, name: '市ケ谷', station_id: 128},
  {code: 64, name: '溜池山王', station_id: 127},
  {code: 65, name: '白金高輪', station_id: 125},
  {code: 67, name: '南北線直通', station_id: 42002},
  {code: 68, name: '南北線・三田線直通', station_id: 42001},
  {code: 71, name: '目黒', station_id: 124},
  {code: 72, name: '不動前', station_id: 123},
  {code: 73, name: '武蔵小山', station_id: 122},
  {code: 74, name: '西小山', station_id: 121},
  {code: 75, name: '洗足', station_id: 120},
  {code: 76, name: '大岡山', station_id: 119},
  {code: 77, name: '奥沢', station_id: 118},
  {code: 107, name: '新綱島', station_id: 61},
  {code: 108, name: '新横浜', station_id: 29},
  {code: 78, name: '渋谷', station_id: 74},
  {code: 79, name: '代官山', station_id: 73},
  {code: 80, name: '中目黒', station_id: 72},
  {code: 81, name: '祐天寺', station_id: 71},
  {code: 82, name: '学芸大学', station_id: 70},
  {code: 83, name: '都立大学', station_id: 69},
  {code: 84, name: '自由が丘', station_id: 68},
  {code: 85, name: '田園調布', station_id: 67},
  {code: 86, name: '多摩川', station_id: 66},
  {code: 87, name: '新丸子', station_id: 65},
  {code: 88, name: '武蔵小杉', station_id: 64},
  {code: 89, name: '元住吉', station_id: 63},
  {code: 90, name: '日吉', station_id: 62},
  {code: 91, name: '綱島', station_id: null},
  {code: 92, name: '大倉山', station_id: null},
  {code: 93, name: '菊名', station_id: 30093},
  {code: 94, name: '妙蓮寺', station_id: null},
  {code: 95, name: '白楽', station_id: null},
  {code: 96, name: '東白楽', station_id: null},
  {code: 97, name: '反町', station_id: null},
  {code: 98, name: '横浜', station_id: 30098},
  {code: 99, name: '新高島', station_id: null},
  {code: 100, name: 'みなとみらい', station_id: 30100},
  {code: 101, name: '馬車道', station_id: null},
  {code: 102, name: '日本大通り', station_id: null},
  {code: 103, name: '元町・中華街', station_id: 30103},
  {code: 111, name: '相鉄線直通', station_id: null},
  {code: 112, name: '西谷', station_id: 8},
  {code: 113, name: '二俣川', station_id: 10},
  {code: 114, name: '瀬谷', station_id: 13},
  {code: 115, name: '大和', station_id: 14},
  {code: 116, name: '相模大塚', station_id: 15},
  {code: 117, name: 'かしわ台', station_id: 17},
  {code: 118, name: '海老名', station_id: 19},
  {code: 119, name: 'いずみ野', station_id: 24},
  {code: 120, name: '湘南台', station_id: 27},
  {code: 121, name: '羽沢横浜国大', station_id: 28},
  {code: 129, name: '蒲田方面', station_id: null},
  {code: 130, name: '沼部', station_id: null},
  {code: 131, name: '鵜の木', station_id: null},
  {code: 132, name: '下丸子', station_id: null},
  {code: 133, name: '武蔵新田', station_id: null},
  {code: 134, name: '矢口渡', station_id: null},
  {code: 135, name: '蒲田', station_id: null},
]


export const NEARBY_STATIONS = {
  1: [ // 横浜
      {id: 1, itemLineId: 1, lineClasses: ['is_center is_line_none']},
      {id: 2, itemLineId: 1, lineClasses: ['is_center']},
      {id: 3, itemLineId: 1, lineClasses: ['is_center']},
      {id: 4, itemLineId: 1, lineClasses: ['is_center']},
      {id: 5, itemLineId: 1, lineClasses: ['is_center']},
      {id: null, lineClasses: ['is_center'], itemClass: 'end-line'},
  ],
  2: [
      {id: 1, itemLineId: 1, lineClasses: ['is_center is_line_none']},
      {id: 2, itemLineId: 1, lineClasses: ['is_center']},
      {id: 3, itemLineId: 1, lineClasses: ['is_center']},
      {id: 4, itemLineId: 1, lineClasses: ['is_center']},
      {id: 5, itemLineId: 1, lineClasses: ['is_center']},
      {id: null, lineClasses: ['is_center'], itemClass: 'end-line'},
  ],
  3: [
      {id: 1, itemLineId: 1, lineClasses: ['is_center is_line_none']},
      {id: 2, itemLineId: 1, lineClasses: ['is_center']},
      {id: 3, itemLineId: 1, lineClasses: ['is_center']},
      {id: 4, itemLineId: 1, lineClasses: ['is_center']},
      {id: 5, itemLineId: 1, lineClasses: ['is_center']},
      {id: null, lineClasses: ['is_center'], itemClass: 'end-line'},
  ],
  4: [
      {id: 2, itemLineId: 1, lineClasses: ['top-line is_center']},
      {id: 3, itemLineId: 1, lineClasses: ['is_center']},
      {id: 4, itemLineId: 1, lineClasses: ['is_center']},
      {id: 5, itemLineId: 1, lineClasses: ['is_center']},
      {id: 6, itemLineId: 1, lineClasses: ['is_center']},
      {id: null,  lineClasses: ['is_center'], itemClass: 'end-line'},
  ],
  5: [ // 星川
      {id: 3, itemLineId: 1, lineClasses: ['top-line is_center']},
      {id: 4, itemLineId: 1, lineClasses: ['is_center']},
      {id: 5, itemLineId: 1, lineClasses: ['is_center']},
      {id: 6, itemLineId: 1, lineClasses: ['is_center']},
      {id: 7, itemLineId: 1, lineClasses: ['is_center']},
      {id: null, lineClasses: ['is_center'], itemClass: 'end-line'},
  ],
  6: [ // 和田町
      {id: 4, itemLineId: 1, lineClasses: ['top-line is_center']},
      {id: 5, itemLineId: 1, lineClasses: ['is_center']},
      {id: 6, itemLineId: 1, lineClasses: ['is_center']},
      {id: 7, itemLineId: 1, lineClasses: ['is_center']},
      {id: 8, itemLineId: 1, lineClasses: ['is_center']},
      {id: null, lineClasses: ['is_center'], itemClass: 'end-line'},
  ],
  7: [ // 上星川
      {id: 5, itemLineId: 1, lineClasses: ['top-line main-line is_center']},
      {id: 6, itemLineId: 1, lineClasses: ['is_center']},
      {id: 7, itemLineId: 1, lineClasses: ['is_center']},
      {id: 8, itemLineId: 1, lineClasses: ['is_center', 'is_center right-line shinyokohama-line']},
      {id: 9, itemLineId: 1, lineClasses: ['is_center']},
      {id: null, lineClasses: ['is_center'], itemClass: 'end-line'},
  ],
  8: [
      [
        {id: 6, itemLineId: 1, lineClasses: ['top-line main-line is_branched_left']},
        {id: 29, itemLineId: 3, lineClasses: ['top-line shinyokohama-line is_branched_right'], itemClass: 'right-position'},
      ],
      [
        {id: 7, itemLineId: 1, lineClasses: ['is_branched_left']},
        {id: 28, itemLineId: 3, lineClasses: ['top-line is_branched_right', 'is_branched_right right-line jr-line'], itemClass: 'right-position'},
      ],
      [
        {id: 8, itemLineId: 1, lineClasses: ['is_branched_left']},
        {id: 8, itemLineId: 3, hiddenStation: true, lineClasses: ['right-curve is_up is_branched_right'], itemClass: 'right-position'},
      ],
      [
        {id: 9, itemLineId: 1, lineClasses: ['is_branched_left']},
        {id: null, lineClasses: [], itemClass: 'right-position'},
      ],
      [
        {id: 10, itemLineId: 1, lineClasses: ['is_branched_left']},
        {id: null, lineClasses: [], itemClass: 'right-position'},
      ],
      [
        {id: null, lineClasses: ['is_branched_left'], itemClass: 'end-line'},
        {id: null, lineClasses: ['right-curve is_down izumino-line is_branched_right'], itemClass: 'end-line right-position branch-end'},
      ],
    ],
  9: [
      [
        {id: 7, itemLineId: 1, lineClasses: ['top-line main-line is_branched_left']},
        {id: 28, itemLineId: 3,lineClasses: ['top-line shinyokohama-line is_branched_right', 'is_branched_right right-line jr-line'], itemClass: 'right-position'},
      ],
      [
        {id: 8, itemLineId: 1, lineClasses: ['is_branched_left']},
        {id: 8, itemLineId: 3, hiddenStation: true, lineClasses: ['right-curve is_up is_branched_right'], itemClass: 'right-position'},
      ],
      [
        {id: 9, itemLineId: 1,lineClasses: ['is_branched_left']},
        {id: null, lineClasses: ['is_line_none is_station_none'], itemClass: 'right-position'},
      ],
      [
        {id: 10, itemLineId: 1, lineClasses: ['is_branched_left']},
        {id: null, lineClasses: ['is_line_none is_station_none'], itemClass: 'right-position'},
      ],
      [
        {id: 11, itemLineId: 1, lineClasses: ['is_branched_left']},
        {id: 21, itemLineId: 2, lineClasses: ['right-curve is_down izumino-line is_branched_right', 'is_line_none is_branched_right'], itemClass: 'right-position'},
      ],
      [
        {id: null, lineClasses: ['is_branched_left'], itemClass: 'end-line'},
        {id: null, lineClasses: ['is_branched_right'], itemClass: 'end-line right-position'},
      ],
    ],
  10: [
      [
        {id: 8, itemLineId: 1, lineClasses: ['top-line main-line is_branched_left']},
        {id: 8, itemLineId: 3, hiddenStation: true, lineClasses: ['right-curve is_up shinyokohama-line is_branched_right'], itemClass: 'right-position'},
      ],
      [
        {id: 9, itemLineId: 1, lineClasses: ['is_branched_left']},
        {id: null, lineClasses: [], itemClass: 'right-position'},
      ],
      [
        {id: 10, itemLineId: 1, lineClasses: ['is_branched_left']},
        {id: null, lineClasses: [], itemClass: 'right-position'},
      ],
      [
        {id: 11, itemLineId: 1, lineClasses: ['is_branched_left']},
        {id: 21, itemLineId: 2, lineClasses: ['right-curve is_down izumino-line is_branched_right', 'is_line_none is_branched_right'], itemClass: 'right-position'},
      ],
      [
        {id: 12, itemLineId: 1, lineClasses: ['is_branched_left']},
        {id: 22, itemLineId: 2, lineClasses: ['is_branched_right'], itemClass: 'right-position'},
      ],
      [
        {id: null, lineClasses: ['is_branched_left'], itemClass: 'end-line'},
        {id: null, lineClasses: ['is_branched_right'], itemClass: 'end-line right-position'},
      ],
    ],
  11: [
      {id: 9, itemLineId: 1, lineClasses: ['top-line main-line is_center']},
      {id: 10, itemLineId: 1, lineClasses: ['is_center', 'is_center right-line izumino-line']},
      {id: 11, itemLineId: 1, lineClasses: ['is_center']},
      {id: 12, itemLineId: 1, lineClasses: ['is_center']},
      {id: 13, itemLineId: 1, lineClasses: ['is_center']},
      {id: null, lineClasses: ['is_center'], itemClass: 'end-line'},
  ],
  12: [
      {id: 10, itemLineId: 1, lineClasses: ['top-line main-line is_center', 'is_center right-line izumino-line']},
      {id: 11, itemLineId: 1, lineClasses: ['is_center']},
      {id: 12, itemLineId: 1, lineClasses: ['is_center']},
      {id: 13, itemLineId: 1, lineClasses: ['is_center']},
      {id: 14, itemLineId: 1, lineClasses: ['is_center']},
      {id: null, lineClasses: ['is_center'], itemClass: 'end-line'},
  ],
  13: [
      {id: 11, itemLineId: 1, lineClasses: ['top-line is_center']},
      {id: 12, itemLineId: 1, lineClasses: ['is_center']},
      {id: 13, itemLineId: 1, lineClasses: ['is_center']},
      {id: 14, itemLineId: 1, lineClasses: ['is_center']},
      {id: 15, itemLineId: 1, lineClasses: ['is_center']},
      {id: null, lineClasses: ['is_center'], itemClass: 'end-line'},
  ],
  14: [
      {id: 12, itemLineId: 1, lineClasses: ['top-line is_center']},
      {id: 13, itemLineId: 1, lineClasses: ['is_center']},
      {id: 14, itemLineId: 1, lineClasses: ['is_center']},
      {id: 15, itemLineId: 1, lineClasses: ['is_center']},
      {id: 16, itemLineId: 1, lineClasses: ['is_center']},
      {id: null, lineClasses: ['is_center'], itemClass: 'end-line'},
  ],
  15: [
      {id: 13, itemLineId: 1, lineClasses: ['top-line is_center']},
      {id: 14, itemLineId: 1, lineClasses: ['is_center']},
      {id: 15, itemLineId: 1, lineClasses: ['is_center']},
      {id: 16, itemLineId: 1, lineClasses: ['is_center']},
      {id: 17, itemLineId: 1, lineClasses: ['is_center']},
      {id: null, lineClasses: ['is_center'], itemClass: 'end-line'},
  ],
  16: [
      {id: 14, itemLineId: 1, lineClasses: ['top-line is_center']},
      {id: 15, itemLineId: 1, lineClasses: ['is_center']},
      {id: 16, itemLineId: 1, lineClasses: ['is_center']},
      {id: 17, itemLineId: 1, lineClasses: ['is_center']},
      {id: 19, itemLineId: 1, lineClasses: ['is_center']},
      {id: null, lineClasses: [], itemClass: 'end-line'},
  ],
  17: [
      {id: 14, itemLineId: 1, lineClasses: ['top-line is_center']},
      {id: 15, itemLineId: 1, lineClasses: ['is_center']},
      {id: 16, itemLineId: 1, lineClasses: ['is_center']},
      {id: 17, itemLineId: 1, lineClasses: ['is_center']},
      {id: 19, itemLineId: 1, lineClasses: ['is_center']},
      {id: null, lineClasses: [], itemClass: 'end-line'},
  ],
  19: [
      {id: 14, itemLineId: 1, lineClasses: ['top-line is_center']},
      {id: 15, itemLineId: 1, lineClasses: ['is_center']},
      {id: 16, itemLineId: 1, lineClasses: ['is_center']},
      {id: 17, itemLineId: 1, lineClasses: ['is_center']},
      {id: 19, itemLineId: 1, lineClasses: ['is_center']},
      {id: null, lineClasses: [], itemClass: 'end-line'},
  ],
  21: [
      {id: 9, itemLineId: 1, lineClasses: ['top-line main-line is_center']},
      {id: 10, itemLineId: 1, lineClasses: ['is_center', 'is_center left-line main-line']},
      {id: 21, itemLineId: 2, lineClasses: ['is_center', 'is_center top-line izumino-line']},
      {id: 22, itemLineId: 2, lineClasses: ['is_center']},
      {id: 23, itemLineId: 2, lineClasses: ['is_center']},
      {id: null, lineClasses: ['is_center'], itemClass: 'end-line'},
  ],
  22: [
      {id: 10, itemLineId: 1, lineClasses: ['top-line main-line is_center', 'is_center left-line main-line']},
      {id: 21, itemLineId: 2, lineClasses: ['is_center top-line izumino-line']},
      {id: 22, itemLineId: 2, lineClasses: ['is_center']},
      {id: 23, itemLineId: 2, lineClasses: ['is_center']},
      {id: 24, itemLineId: 2, lineClasses: ['is_center']},
      {id: null, lineClasses: ['is_center'], itemClass: 'end-line'},
  ],
  23: [
      {id: 21, itemLineId: 2, lineClasses: ['top-line is_center']},
      {id: 22, itemLineId: 2, lineClasses: ['is_center']},
      {id: 23, itemLineId: 2, lineClasses: ['is_center']},
      {id: 24, itemLineId: 2, lineClasses: ['is_center']},
      {id: 25, itemLineId: 2, lineClasses: ['is_center']},
      {id: null, lineClasses: ['is_center'], itemClass: 'end-line'},
  ],
  24: [
      {id: 22, itemLineId: 2, lineClasses: ['top-line is_center']},
      {id: 23, itemLineId: 2, lineClasses: ['is_center']},
      {id: 24, itemLineId: 2, lineClasses: ['is_center']},
      {id: 25, itemLineId: 2, lineClasses: ['is_center']},
      {id: 26, itemLineId: 2, lineClasses: ['is_center']},
      {id: null, lineClasses: ['is_center'], itemClass: 'end-line'},  ],
  25: [
      {id: 23, itemLineId: 2, lineClasses: ['top-line is_center']},
      {id: 24, itemLineId: 2, lineClasses: ['is_center']},
      {id: 25, itemLineId: 2, lineClasses: ['is_center']},
      {id: 26, itemLineId: 2, lineClasses: ['is_center']},
      {id: 27, itemLineId: 2, lineClasses: ['is_center']},
      {id: null, lineClasses: [], itemClass: 'end-line'},
  ],
  26: [
      {id: 23, itemLineId: 2, lineClasses: ['top-line is_center']},
      {id: 24, itemLineId: 2, lineClasses: ['is_center']},
      {id: 25, itemLineId: 2, lineClasses: ['is_center']},
      {id: 26, itemLineId: 2, lineClasses: ['is_center']},
      {id: 27, itemLineId: 2, lineClasses: ['is_center']},
      {id: null, lineClasses: [], itemClass: 'end-line'},
  ],
  27: [
      {id: 23, itemLineId: 2, lineClasses: ['top-line is_center']},
      {id: 24, itemLineId: 2, lineClasses: ['is_center']},
      {id: 25, itemLineId: 2, lineClasses: ['is_center']},
      {id: 26, itemLineId: 2, lineClasses: ['is_center']},
      {id: 27, itemLineId: 2, lineClasses: ['is_center']},
      {id: null, lineClasses: [], itemClass: 'end-line'},
  ],
  28: [
       [
         {id: 61, itemLineId: 3, lineClasses: ['is_other top-line tokyu-line is_branched_left']},
         {id: 11101, itemLineId: 4, lineClasses: ['top-line jr-line is_branched_right'], itemClass: 'right-position'},
       ],
       [
         {id: 29, itemLineId: 3, lineClasses: ['is_branched_left']},
         {id: 11464, itemLineId: 4, lineClasses: ['is_branched_right'], itemClass: 'right-position'},
       ],
       [
         {id: 28, itemLineId: 3, lineClasses: ['is_branched_left top-line shinyokohama-line']},
         {id: 28, itemLineId: 4, hiddenStation: true, lineClasses: ['is_branched_right right-curve is_up'], itemClass: 'right-position'},
       ],
       [
         {id: 8, itemLineId: 3, lineClasses: ['is_branched_left', 'is_branched_left left-line main-line-up']},
         {id: null, lineClasses: [], itemClass: 'right-position'},
       ],
       [
         {id: 9, itemLineId: 3, lineClasses: ['is_branched_left top-line main-line-down']},
         {id: null, lineClasses: ['is_line_none is_station_none'], itemClass: 'right-position'},
       ],
       [
         {id: null, lineClasses: ['is_branched_left'], itemClass: 'end-line'},
         {id: null, lineClasses: [], itemClass: 'end-line right-position'},
       ],
  ],
  29: [
      {id: 62, itemLineId: 3, lineClasses: ['top-line is_center is_other tokyu-line']},
      {id: 61, itemLineId: 3, lineClasses: ['is_center is_other']},
      {id: 29, itemLineId: 3, lineClasses: ['is_center']},
      {id: 28, itemLineId: 3, lineClasses: ['is_center top-line shinyokohama-line', 'is_center right-line jr-line']},
      {id: 8, itemLineId: 3, lineClasses: ['is_center left-line main-line', 'is_center']},
      {id: null, lineClasses: ['is_center'], itemClass: 'end-line'},
  ],
}
